import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  noDetailsAvailable = 'No details available for current Report Period.'
  noReportPeriodAvailable = 'No Report Period available.'
  noHistoryDetailsAvailable = 'No details available for the selected Report Period.'
  noAllDetailsAvailable = 'No details available.'
  serverErrMsg = 'Unable To Connect To The Server.'
  notAbleToGetReportPeriodName = 'Unable to get Report Period name.'
  notAbleToGetReportPeriodInfoDetails = 'Unable to get Report Period details.'
  dataUpdateFailure = 'Data Update Failed. Please review and try again.'
  updateSupplierUnionContPath = 'Please update the path in Admin tab to redirect.'
  notAbleToGetFilterDetails = 'Unable to get Report Period filter details.'
  downloadFileErrMsg = 'Unable to download the file. Please try again.'

  unionTypeErrorMsg = 'Union Type must be selected.'
  evaluationErrorMsg = 'Overall evaluation must be selected.'
  monthlyConfirmationErrorMsg = 'Monthly Confirmation must be checked.'
  contingencyPlanErrorMsg = 'Contingency plan developed / on schedule; if unchecked (No) then must provide text in Contingency Plan Summary.'
  statusCommentErrorMsg = 'Overall Status Comment cannot be blank.'

  constructor() { }
}
